
import { Button, Box, useTheme, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../Dashboard/Header";

import { useNavigate } from "react-router-dom";

const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function AutoBankReconcile() {
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const [pageSize, setPageSize] = useState(20);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  // const [BankRecData, SetBankRecData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  // =================================================

  const BankRecData = [
    {
      vch_id: 1,
      vchB_bankersdate: "2025-09-01",
      PartyName: "ABC Traders",
      vch_type: "Receipt",
      InstrumentNo: "CHQ12345",
      InstrumentDate: "2025-08-28",
      BankDate: "2025-09-02",
      Deposite: 5000,
      Withdrawal: 0,
    },
    {
      vch_id: 2,
      vchB_bankersdate: "2025-09-02",
      PartyName: "XYZ Enterprises",
      vch_type: "Payment",
      InstrumentNo: "CHQ54321",
      InstrumentDate: "2025-08-30",
      BankDate: "2025-09-03",
      Deposite: 0,
      Withdrawal: 2500,
    },
    {
      vch_id: 3,
      vchB_bankersdate: "2025-09-03",
      PartyName: "MNO Services",
      vch_type: "Receipt",
      InstrumentNo: "NEFT98765",
      InstrumentDate: "2025-09-01",
      BankDate: "2025-09-04",
      Deposite: 10000,
      Withdrawal: 0,
    },
  ];

  const rows = Array.isArray(BankRecData)
    ? BankRecData.map((BnkData) => ({
        id: BnkData.vch_id,
        Date: BnkData.vchB_bankersdate,
        partyName: BnkData.PartyName,
        vchTypes: BnkData.vch_type,
        InstrumentNo: BnkData.InstrumentNo,
        InstrumentDate: BnkData.InstrumentDate,
        BankDate: BnkData.BankDate,
        Deposite: BnkData.Deposite,
        Withdrawal: BnkData.Withdrawal,
      }))
    : [];

  //-------------------------------------------------------

  const columns = [
    {
      field: "Date",
      headerName: "Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "vchTypes",
      headerName: "Voucher Types",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "partyName",
      headerName: "Perticular",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "InstrumentNo",
      headerName: "Instrument No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "InstrumentDate",
      headerName: "Instrument Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "BankDate",
      headerName: "Bank Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
      renderCell: (params) => {
        return (
          <TextField
            type="date"
            size="small"
            variant="outlined"
            value={params.value || ""}
            onChange={(e) => {
              const newValue = e.target.value;

              // Update the row value
              params.api.updateRows([{ id: params.id, BankDate: newValue }]);
            }}
            sx={{
              "& input": {
                fontSize: preferences.fontSize,
                fontFamily: preferences.fontFamily,
                textAlign: "center",
              },

              backgroundColor: "transparent",
              height: preferences.rowHeight - 5,
            }}
          />
        );
      },
    },

    {
      field: "Deposite",
      headerName: "Deposite",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "Withdrawal",
      headerName: "Withdrawal",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
  ];

  return (
    <Box mt="80px" ml="20px" mr="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="Bank Reconcilation"
          subtitle="Auto Bank Reconcilation"
        />

        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: colors.blueAccent[700], // Custom background color
              color: colors.primary[150], // Custom text color
              "&:hover": {
                backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                color: colors.primary[150], // Maintain the same text color on hover
              },
            }}
            type="button"
          >
            Reconcile
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              borderColor: "black",
              color: "white",
            }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
      </Box>

      {/* vouchers table  */}
      <Box
        height="74vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { border: "none", cursor: "pointer" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiDataGrid-cell:focus": { outline: "none" },
          "& .MBReczoom-row:hover": {
            transform: "scale(1.01)",
            transition: "transform 0.2s ease-in-out",
            zIndex: 1,
            backgroundColor: colors.blueAccent[900],
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowHeight={parseInt(preferences.rowHeight)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[20, 50, 100]}
          getRowClassName={() => "MBReczoom-row"}
          pagination
          checkboxSelection
          onSelectionModelChange={(newSelection) =>
            setSelectedIds(newSelection)
          }
        />
      </Box>
    </Box>
  );
}

